@use "../../../styles/accessibility";

.checkboxInput {
  --ixf-checkbox-label-font-size: 0.875rem;
  --ixf-checkbox-label-line-height: 1.125rem;
  --ixf-checkbox-label-font-weight: var(--ixf-font-weight-main-medium);
  --ixf-checkbox-background-color: var(--ixf-color-background);
  --ixf-checkbox-border-color: var(--ixf-color-separator);
  --ixf-checkbox-focus-border-color: var(--ixf-text-tone-md);

  // Default size: medium
  --ixf-checkbox-height: var(--ixf-space-6);
  --ixf-checkbox-width: var(--ixf-space-6);
  --ixf-checkbox-indicator-height: var(--ixf-space-4);
  --ixf-checkbox-indicator-width: var(--ixf-space-4);
  --ixf-checkbox-border-radius: 6px;

  &.size {
    &-small {
      --ixf-checkbox-height: var(--ixf-space-4);
      --ixf-checkbox-width: var(--ixf-space-4);
      --ixf-checkbox-border-radius: 4px;
    }
  }

  .isDisabled {
    opacity: var(--ixf-input-disabled-opacity);
  }

  .label {
    font-size: var(--ixf-checkbox-label-font-size);
    line-height: var(--ixf-checkbox-label-line-height);
    font-weight: var(--ixf-checkbox-label-font-weight);

    &.isHidden {
      @include accessibility.visually-hidden;
    }
  }

  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--ixf-checkbox-height);
    width: var(--ixf-checkbox-width);
    background: var(--ixf-checkbox-background-color);
    border: 1px solid var(--ixf-checkbox-border-color);
    border-radius: var(--ixf-checkbox-border-radius);
    flex: 0 0 auto;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      border: 2px solid var(--ixf-checkbox-focus-border-color);
    }

    .indicator {
      display: flex;
      align-items: center;
      justify-content: center;
      height: var(--ixf-checkbox-indicator-height);
      width: var(--ixf-checkbox-indicator-width);

      path {
        fill: var(--ixf-text-tone-md) !important;
      }
    }
  }
}
